import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import JoinedguestListLayer from "../../components/JoinedGuestList/JoinedguestListLayer";

const ScannedGuestList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Scanned Guest List" />
        <JoinedguestListLayer
          status="scanned"
          viewBasePath="/scannedGuest"
        />
      </MasterLayout>
    </>
  );
};

export default ScannedGuestList;
